import React from 'react';
import PropTypes from 'prop-types';
import OwlCarousel from 'react-owl-carousel';
import { isMobile } from 'common/helpers';

import { images } from './constants';

class Carousel extends React.Component {
  componentDidMount() {
    if (this.props.innerRef) {
      this.props.innerRef(this.slider);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <OwlCarousel
        items={1}
        ref={(ref) => { this.slider = ref; }}
        loop={true}
        autoplay={true}
        onChanged={this.props.onChange}
        dots={true}
        dotsEach={true}
        nav={isMobile()}
        navText={['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>']}
      >
        {images.map((image) =>
          <div key={image.img} style={{ backgroundImage: `url("${image.img}")` }} />
        )}
      </OwlCarousel>
    );
  }
}

Carousel.propTypes = {
  innerRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/containers/Hotel/Carousel.js